const cn = {
    protect_free: '技术保护',
    protect_trial: '技术保护',
    protect_commercial_old: '技术保护',
    protect_commercial: '技术保护',
    material_trial: '新材料',
    material_commercial_old: '新材料',
    material_commercial: '新材料',
    material_commercial_rapid_search: '材料速研版',
    material_credits_trial: '新材料',
    material_credits_commercial: '新材料',
    air_free: 'Eureka 基础版',
    air_trial: '技术方案',
    air_commercial: '技术方案',
    unlock_skills_trial: 'Eureka 试用版',
    insights_trial: '研发情报',
    insights_commercial: '研发情报',
    air_commercial_professional_edition: '研发专业版',
    air_commercial_professional_edition_trial: '研发专业版',
    air_commercial_navigator_edition: '研发领航版',
    air_commercial_navigator_edition_trial: '研发领航版',
    feishu_trial: 'Eureka 研发专业版（试用）',

    ls_trial: '生物医药 (试用)',
    ls_trial_five: '生物医药',
    ls_commercial: '生物医药',
    ls_commercial_share: '生物医药专业版',
    ls_commercial_share_trial: '生物医药 (试用)',
    ls_trial_hiro: '生物医药百科问答 & 文档精读 (试用)',
    ls_trial_hiro_full: '生物医药百科问答 & 文档精读 (试用)',
    ls_commercial_hiro: '生物医药百科问答 & 文档精读',
    ls_commercial_pharma: '生物医药百科问答 & 文档精读',
    ls_commercial_draft: '马库什权要撰写 ',
    ls_commercial_antibody: '优选抗体推荐',
    ls_commercial_launch: '药物知产报告',
    ls_commercial_agent: '生物医药增强包',

    ip_commercial: '知识产权',
    ip_trial_novelty_drafting: '知识产权',
    ip_trial_infringement: '防侵权检索',
    ip_trial_novelty: '查新检索',
    ip_commercial_specification_cnipa: '专利说明书撰写(CNIPA)',
    ip_commercial_specification_uspto: '专利说明书撰写(USPTO)',
    ip_commercial_specification_epo: '专利说明书撰写(EPO)',
    ip_commercial_design_infringement: '外观防侵权检索',
    ip_commercial_infringement: '防侵权检索',
    ip_commercial_disclosure: '技术交底书撰写',
    ip_commercial_translation: '专利翻译',
    ip_commercial_novelty: '查新检索',
    ip_commercial_novelty_draft: 'AI查新&撰写',
    ip_commercial_draft: 'AI撰写',
    ip_plg_free: 'Eureka IP 通用流量(免费版)',

    rd_plg_freemium: 'Eureka 免费版',
    rd_personal_commercial: 'Eureka 工程创新 个人版',

    material_pro: 'MSE Pro',
    ls_plg_personal_pro: 'LS Pro',
    // 和 MainPackageEnum对应
    ip_checking_pro: 'IP 检索 专业版',
    ip_checking_pro_year: 'IP 检索 专业版',
    ip_checking_enterprise: 'IP 检索 企业版',

    // 0701 积分套餐
    agent_personal_commercial: 'Eureka 个人付费版',
    ls_commercial_credits: 'Eureka 生命科学',
    ls_trial_credits: 'Eureka 生命科学 (试用)',
    air_commercial_credits: 'Eureka工程创新',
    air_trial_credits: 'Eureka工程创新（试用）',
    ip_searching_commercial_credits: 'Eureka IP 检索',
    ip_searching_trial_credits: 'Eureka IP 检索（试用）',
    ip_drafting_max: 'Eureka IP 撰写 Max',
    ip_drafting_slg_max: 'Eureka IP 撰写 Max',
    ip_drafting: 'Eureka IP 撰写',
    ip_drafting_trail: 'Eureka IP 撰写-试用',
    telecom_agent_commercial: 'Eureka 通信版',
    telecom_agent_trial: 'Eureka 通信版（试用）',
}

const en = {
    protect_free: 'Eureka Search',
    protect_trial: 'Eureka Search',
    protect_commercial_old: 'Eureka Search',
    protect_commercial: 'Eureka Search',
    material_trial: 'Eureka Materials',
    material_commercial_old: 'Eureka Materials',
    material_commercial: 'Eureka Materials',
    material_commercial_rapid_search: 'Materials Express',
    material_credits_trial: 'Eureka Materials',
    material_credits_commercial: 'Eureka Materials',
    air_free: 'Eureka Basic',
    air_trial: 'Eureka Ideas',
    air_commercial: 'Eureka Ideas',
    unlock_skills_trial: 'Eureka Trial',
    insights_trial: 'Eureka Scout',
    insights_commercial: 'Eureka Scout',
    air_commercial_professional_edition: 'R&D Professional Edition',
    air_commercial_professional_edition_trial: 'R&D Professional Edition',
    air_commercial_navigator_edition: 'R&D Pilot Edition',
    air_commercial_navigator_edition_trial: 'R&D Pilot Edition',
    feishu_trial: 'Eureka R&D Professional Edition (Trial)',

    ls_trial: 'Life Sciences (Trial)',
    ls_trial_five: 'Life Sciences',
    ls_commercial: 'Life Sciences',
    ls_commercial_share: 'Life Sciences Professional',
    ls_commercial_share_trial: 'Life Sciences (Trial)',
    ls_trial_hiro: 'Life Sciences - PIA & PDA (Trial)',
    ls_trial_hiro_full: 'Life Sciences - PIA & PDA (Trial)',
    ls_commercial_hiro: 'Life Sciences - PIA & PDA',
    ls_commercial_pharma: 'Life Sciences - PIA & PDA',
    ls_commercial_draft: 'Life Sciences - MCD',
    ls_commercial_antibody: 'Life Sciences - ATP',
    ls_commercial_launch: 'Life Sciences - PCIE',
    ls_commercial_agent: 'Life Sciences Usage Package',

    ip_commercial: 'IP',
    ip_trial_novelty_drafting: 'IP',
    ip_trial_infringement: 'IP - FTO Search',
    ip_trial_novelty: 'IP - Novelty Search',
    ip_commercial_specification_cnipa: 'IP - Patent Drafting (CNIPA)',
    ip_commercial_specification_uspto: 'IP - Patent Drafting (USPTO)',
    ip_commercial_specification_epo: 'IP - Patent Drafting (EPO)',
    ip_commercial_design_infringement: 'IP - Design FTO Search',
    ip_commercial_infringement: 'IP - FTO Search',
    ip_commercial_disclosure: 'IP - Invention Disclosure',
    ip_commercial_translation: 'IP - Patent Translation',
    ip_commercial_novelty: 'IP - Novelty Search',
    ip_commercial_novelty_draft: 'IP - AI Novelty Search & AI Drafting',
    ip_commercial_draft: 'IP - AI Drafting',
    ip_plg_free: 'Eureka IP General Traffic (Free)',

    rd_plg_freemium: 'Eureka Freemium',
    rd_personal_commercial: 'Eureka ENG PRO',

    material_pro: 'MSE Pro',
    ls_plg_personal_pro: 'LS Pro',
    ip_checking_pro: 'IP Searching Pro',
    ip_checking_pro_year: 'IP Searching Pro',
    ip_checking_enterprise: 'IP Searching Enterprise',

    // 0701 积分套餐
    agent_personal_commercial: 'Eureka Pro',
    ls_commercial_credits: 'Eureka LifeSciences',
    ls_trial_credits: 'Eureka LifeSciences (Trial)',
    air_commercial_credits: 'Eureka Engineering',
    air_trial_credits: 'Eureka Engineering (Trial)',
    ip_searching_commercial_credits: 'Eureka IP Searching',
    ip_searching_trial_credits: 'Eureka IP Searching(Trial)',
    ip_drafting_max: 'Eureka IP Drafting Max',
    ip_drafting_slg_max: 'Eureka IP Drafting Max',
    ip_drafting: 'Eureka IP Drafting',
    ip_drafting_trail: 'Eureka IP Drafting-trail',
    telecom_agent_commercial: 'Eureka Telecom',
    telecom_agent_trial: 'Eureka Telecom Trial',
}

const tw = {
    protect_free: '科技保護',
    protect_trial: '科技保護',
    protect_commercial_old: '科技保護',
    protect_commercial: '科技保護',
    material_trial: '新材料',
    material_commercial_old: '新材料',
    material_commercial: '新材料',
    material_commercial_rapid_search: '材料速研版',
    material_credits_trial: '新材料',
    material_credits_commercial: '新材料',
    air_free: 'Eureka 基礎版',
    air_trial: '科技方案',
    air_commercial: '科技方案',
    unlock_skills_trial: 'Eureka 試用版',
    insights_trial: '研發情報',
    insights_commercial: '研發情報',
    air_commercial_professional_edition: '研發專業版',
    air_commercial_professional_edition_trial: '研發專業版',
    air_commercial_navigator_edition: '研發領航版',
    air_commercial_navigator_edition_trial: '研發領航版',
    feishu_trial: 'Eureka 研發專業版（試用）',

    ls_trial: '生物醫藥 (試用)',
    ls_trial_five: '生物醫藥',
    ls_commercial: '生物醫藥',
    ls_commercial_share: '生物醫藥專業版',
    ls_commercial_share_trial: '生物醫藥 (試用)',
    ls_trial_hiro: '生物醫藥百科問答 & 文檔精讀 (試用)',
    ls_trial_hiro_full: '生物醫藥百科問答 & 文檔精讀 (試用)',
    ls_commercial_hiro: '生物醫藥百科問答 & 文檔精讀',
    ls_commercial_pharma: '生物醫藥百科問答 & 文檔精讀',
    ls_commercial_draft: '馬庫什權要撰寫 ',
    ls_commercial_antibody: '優選抗體推薦',
    ls_commercial_launch: '藥物知產報告',
    ls_commercial_agent: '生物醫藥增強包',

    ip_commercial: '知識產權',
    ip_trial_novelty_drafting: '知識產權',
    ip_trial_infringement: '防侵權檢索',
    ip_trial_novelty: '查新檢索',
    ip_commercial_specification_cnipa: '專利說明書撰寫(CNIPA)',
    ip_commercial_specification_uspto: '專利說明書撰寫(USPTO)',
    ip_commercial_specification_epo: '專利說明書撰寫(EPO)',
    ip_commercial_design_infringement: '外觀防侵權檢索',
    ip_commercial_infringement: '防侵權檢索',
    ip_commercial_disclosure: '技術交底書撰寫',
    ip_commercial_translation: '專利翻譯',
    ip_commercial_novelty: '查新檢索',
    ip_commercial_novelty_draft: 'AI查新&撰寫',
    ip_commercial_draft: 'AI撰寫',
    ip_plg_free: 'Eureka IP 通用流量(免費版)',

    rd_plg_freemium: 'Eureka 免費版',
    rd_personal_commercial: 'Eureka 工程創新 個人版',

    material_pro: 'MSE Pro',
    ls_plg_personal_pro: 'LS Pro',
    ip_checking_pro: 'IP 檢索 專業版',
    ip_checking_pro_year: 'IP 檢索 專業版',
    ip_checking_enterprise: 'IP 檢索 企業版',

    // 0701 积分套餐
    agent_personal_commercial: 'Eureka Pro',
    ls_commercial_credits: 'Eureka 生命科學',
    ls_trial_credits: 'Eureka 生命科學 (試用)',
    air_commercial_credits: 'Eureka 工程創新',
    air_trial_credits: 'Eureka 工程創新（試用）',
    ip_searching_commercial_credits: 'Eureka IP 檢索',
    ip_searching_trial_credits: 'Eureka IP 檢索（試用）',
    ip_drafting_max: 'Eureka IP 撰寫 Max',
    ip_drafting_slg_max: 'Eureka IP 撰寫 Max',
    ip_drafting: 'Eureka IP 撰寫',
    ip_drafting_trail: 'Eureka IP 撰寫-試用',
    telecom_agent_commercial: 'Eureka 通信版',
    telecom_agent_trial: 'Eureka 通信版（試用）',
}

const jp = {
    protect_free: '計画保護',
    protect_trial: '計画保護',
    protect_commercial_old: '計画保護',
    protect_commercial: '計画保護',
    material_trial: '材料科学',
    material_commercial_old: '材料科学',
    material_commercial: '材料科学',
    material_commercial_rapid_search: '材料クイック研究版',
    material_credits_trial: '材料科学',
    material_credits_commercial: '材料科学',
    air_free: 'Eureka 基礎版',
    air_trial: '研究開発計画',
    air_commercial: '研究開発計画',
    unlock_skills_trial: 'Eureka 体験版',
    insights_trial: 'Eureka Scout',
    insights_commercial: 'Eureka Scout',
    air_commercial_professional_edition: '研究開発プロフェッショナル版',
    air_commercial_professional_edition_trial: '研究開発プロフェッショナル版',
    air_commercial_navigator_edition: '研究開発ナビゲーター版',
    air_commercial_navigator_edition_trial: '研究開発ナビゲーター版',
    feishu_trial: 'Eureka 研究開発プロフェッショナル版（体験版）',

    ls_trial: 'ライフサイエンス (試用)',
    ls_trial_five: 'ライフサイエンス',
    ls_commercial: 'ライフサイエンス',
    ls_commercial_share: 'ライフサイエンス プロフェッショナル版',
    ls_commercial_share_trial: 'ライフサイエンス (試用)',
    ls_trial_hiro: 'ライフサイエンス百科Q&A & 文書精読 (試用)',
    ls_trial_hiro_full: 'ライフサイエンス百科Q&A & 文書精読 (試用)',
    ls_commercial_hiro: 'ライフサイエンス百科Q&A & 文書精読',
    ls_commercial_pharma: 'ライフサイエンス百科Q&A & 文書精読',
    ls_commercial_draft: 'マーカッシュ権利要件作成',
    ls_commercial_antibody: '最適抗体推薦',
    ls_commercial_launch: '医薬知財レポート',
    ls_commercial_agent: 'ライフサイエンス 拡張パック',

    ip_commercial: 'IP',
    ip_trial_novelty_drafting: 'IP',
    ip_trial_infringement: 'IP - FTO Search',
    ip_trial_novelty: 'IP - Novelty Search',
    ip_commercial_specification_cnipa: 'IP - Patent Drafting (CNIPA)',
    ip_commercial_specification_uspto: 'IP - Patent Drafting (USPTO)',
    ip_commercial_specification_epo: 'IP - Patent Drafting (EPO)',
    ip_commercial_design_infringement: 'IP - Design FTO Search',
    ip_commercial_infringement: 'IP - FTO Search',
    ip_commercial_disclosure: 'IP - Invention Disclosure',
    ip_commercial_translation: 'IP - Patent Translation',
    ip_commercial_novelty: 'IP - Novelty Search',
    ip_commercial_novelty_draft: 'IP - AI Novelty Search & AI Drafting',
    ip_commercial_draft: 'IP - AI Drafting',
    ip_plg_free: 'Eureka IP ユニバーサルトラフィック(無料版)',

    rd_plg_freemium: 'Eureka 無料版',
    rd_personal_commercial: 'Eureka エンジニアリングイノベーション 個人版',

    material_pro: 'MSE Pro',
    ls_plg_personal_pro: 'LS Pro',
    ip_checking_pro: 'IP Searching Pro',
    ip_checking_pro_year: 'IP Searching Pro',
    ip_checking_enterprise: 'IP Searching Enterprise',

    // 0701 积分套餐
    agent_personal_commercial: 'Eureka Pro',
    ls_commercial_credits: 'Eureka LifeSciences',
    ls_trial_credits: 'Eureka LifeSciences (Trial)',
    air_commercial_credits: 'Eureka Engineering',
    air_trial_credits: 'Eureka Engineering (Trial)',
    ip_searching_commercial_credits: 'Eureka IP 検索',
    ip_searching_trial_credits: 'Eureka IP 検索（試用）',
    ip_drafting_max: 'Eureka IP 作成 Max',
    ip_drafting_slg_max: 'Eureka IP 作成 Max',
    ip_drafting: 'Eureka IP 作成',
    ip_drafting_trail: 'Eureka IP 作成-試用',
    telecom_agent_commercial: 'Eureka 通信版',
    telecom_agent_trial: 'Eureka 通信版（試用）',
}

export {
    cn,
    en,
    tw,
    jp,
};
